import { jsx as _jsx } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/tooltip.scss';
import { Tooltip } from 'react-tooltip';
import { TooltipBehavior } from './TooltipTypes';
export const TooltipError = () => {
    return (_jsx(Tooltip, { id: TooltipBehavior.Error, border: '1px solid var(--semantic-border-error)', openEvents: { mouseenter: true }, closeEvents: { blur: true }, globalCloseEvents: { clickOutsideAnchor: true }, offset: 5, delayHide: 0 }));
};
